import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { IconButton, MenuItem, Select, Stack } from "@mui/material";
import { useMemo } from "react";

const yearArrayFromRange = (startYear, endYear) => {
	const years = [];

	for (let year = startYear; year <= endYear; year++) {
		years.push(year);
	}

	return years;
};

const utils = {
	yearArrayFromRange,
};

export const YearSelect = ({
	value,
	minYear,
	maxYear,
	onChange,
	hideControls,
	small,
	disabled,
}) => {
	const options = useMemo(
		() => utils.yearArrayFromRange(minYear, maxYear),
		[minYear, maxYear]
	);

	const select = (
		<Select
			size="small"
			autoWidth
			disabled={disabled}
			value={value}
			sx={{
				"& .MuiSelect-select": { py: small ? "4px" : undefined },
			}}
			onChange={(event) => onChange(event.target.value)}
		>
			{options.map((option) => (
				<MenuItem key={option} value={option}>
					{option}
				</MenuItem>
			))}
		</Select>
	);

	if (hideControls) {
		return select;
	}

	return (
        <Stack direction="row" spacing={small ? 1 : 2} sx={{
            alignItems: "center"
        }}>
            <IconButton
				disabled={value - 1 < minYear}
				size={small ? "small" : undefined}
				onClick={() => {
					onChange(value - 1);
				}}
			>
				<KeyboardArrowLeftIcon />
			</IconButton>
            {select}
            <IconButton
				size={small ? "small" : undefined}
				disabled={value + 1 > maxYear}
				onClick={() => {
					onChange(value + 1);
				}}
			>
				<KeyboardArrowRightIcon />
			</IconButton>
        </Stack>
    );
};
